import React, { FC, useCallback, useMemo } from 'react';
import './styles.scss';
import classNames from 'classnames';
import {
  EmmaIcon,
  EmmaSpace,
  EmmaStringTemplate,
  EmmaText,
} from '@axa-asia/emma-stylesheet';
import { resolveLocalizedText } from '../../../../utils';
import ChangeAddressContent from '../../i18n/changeAddressContent';
import Color from '@axa-asia/emma-stylesheet/styles/common/_color.scss';
import { gaClickAbleElement } from '../../../../utils/generalGaEventAnalytics';

type StreetMessageBannerProps = {
  className?: string;
  onContentClick?: () => void;
};

const StreetMessageBanner: FC<StreetMessageBannerProps> = ({
  className,
  onContentClick,
}) => {
  const streetBuildingEstateMessage = useMemo(() => {
    return resolveLocalizedText(
      ChangeAddressContent.streetBuildingEstateMessage.content,
    );
  }, [ChangeAddressContent]);
  const guideline = useMemo(() => {
    return resolveLocalizedText(
      ChangeAddressContent.streetBuildingEstateMessage.guideline,
    );
  }, [ChangeAddressContent]);

  const handleClickGuideline = useCallback(() => {
    gaClickAbleElement(guideline);
    onContentClick && onContentClick();
  }, [onContentClick, guideline]);

  return (
    <div className={classNames('streetMessageBanner-container', className)}>
      <EmmaIcon iconKey={'functional/alert'} size={24} />
      <div className={EmmaSpace.ml8}>
        <EmmaStringTemplate
          className={EmmaText['BodyTextS/line-15em/Left/MineShaft']}
          template={streetBuildingEstateMessage}
          items={{
            guideline: {
              text: guideline,
              onClick: handleClickGuideline,
              style: {
                color: Color.indigo,
                cursor: 'pointer',
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default StreetMessageBanner;
